// 'fade' | 'fromTop' | 'fromRight' | 'fromBottom' | 'fromLeft' | 'rotate' | 'scale'

export enum NotificationAnimationsType {
  Fade = 'fade',
  FromTop = 'fromTop',
  FromRight = 'fromRight',
  FromBottom = 'fromBottom',
  FromLeft = 'fromLeft',
  Rotate = 'rotate',
  Scale = 'scale'
}

export enum NotificationAnimationsStatus {
  In = 'In',
  Out = 'Out'
}
